/* eslint-disable consistent-return */
/* eslint-disable import/prefer-default-export */
/* eslint-disable-next-line array-callback-return */

import { loginFieldsSchema } from './FieldsUtility'
import { isNullOrEmpty, updateObject } from './Utility'

const getFieldValue = (fieldsState, key, sensitiveFields = {}) => {
  if (Object.prototype.hasOwnProperty.call(sensitiveFields, key)) {
    return isNullOrEmpty(sensitiveFields[key])
  }

  return isNullOrEmpty(fieldsState[key] && fieldsState[key].value)
}

/**
 *
 * @param {object} fieldsSchema - schema contains fields definition
 * @param {string} key - name of the field
 */
function getNotification(fieldsSchema, key) {
  return {
    text: 'Correct ',
    linkText: fieldsSchema[key].label,
    link: `#${fieldsSchema[key].id}`
    // .replace(/\s/g, '')}`
  }
}

/**
 * Checks for user errors
 * @param {state} fieldsState - state contains all user state values.
 * @returns {boolean} -  Returns true if the user state has no validation error
 */
export const isPageValid = fieldsState => {
  // eslint-disable-next-line array-callback-return
  Object.keys(fieldsState).map(key => {
    const field = fieldsState[key]
    if (field.isError) return false
  })
  return true
}

/**
 * Validates pattern and isRequired for the given element and sets error state to true or false
 * @param {string} fieldKey - field key which represents field.
 * @param {state} loginfieldState - state contains all user input values.
 * @param {func} setFieldsState - method to update state
 * @param {boolean} isNewUser - is selected user is NEW?
 */
export const isFieldValid = (fieldKey, loginfieldState, setFieldsState, sensitiveFields = {}) => {
  const fieldValue = getFieldValue({ [fieldKey]: loginfieldState }, fieldKey, sensitiveFields)
  const { pattern, isRequired } = loginFieldsSchema[fieldKey]
  let iserror = false
  const isSensitiveField = fieldKey === 'credential' || fieldKey === 'confirmCredential'

  if (isRequired && fieldValue === '') iserror = true

  if (!iserror && fieldValue.length > 0 && isNullOrEmpty(pattern) !== '') {
    iserror = !pattern.test(fieldValue)
  }

  if (iserror) {
    setFieldsState({ [fieldKey]: updateObject(loginfieldState, { isError: true }) })
    return false
  }

  // if no validation errors, update field isError to false
  if (isSensitiveField && Object.prototype.hasOwnProperty.call(sensitiveFields, fieldKey)) {
    setFieldsState({ [fieldKey]: updateObject(loginfieldState, { isError: false }) })
  } else {
    setFieldsState({ [fieldKey]: updateObject(loginfieldState, { isError: false, value: fieldValue }) })
  }
  return true
}

/**
 * Validates fields on form submit and sets errors state, which inturn
 * triggers page render which shows error messages warnings
 * @returns {number} -  Returns user errors count.
 * @param {state} loginfieldsState - current state of the fields
 * @param {function} setFieldsState - function to set the fields state
 * @param {function} setLoginErrors - function to set the page level errors
 */
export const ValidateSubmit = (
  loginfieldsState,
  setFieldsState,
  setLoginErrors,
  validationType,
  sensitiveFields = {}
) => {
  const errors = []

  // eslint-disable-next-line array-callback-return
  Object.keys(loginfieldsState).map(key => {
    const field = loginfieldsState[key]
    if (field.validationType.includes(validationType)) {
      if (!isFieldValid(key, field, setFieldsState, sensitiveFields)) {
        errors.push(getNotification(loginFieldsSchema, key))
      }
    }
  })

  // validate password mismatch
  if (
    getFieldValue(loginfieldsState, 'credential', sensitiveFields) !== '' &&
    getFieldValue(loginfieldsState, 'confirmCredential', sensitiveFields) !== '' &&
    getFieldValue(loginfieldsState, 'credential', sensitiveFields) !== getFieldValue(loginfieldsState, 'confirmCredential', sensitiveFields)
  ) {
    setFieldsState({
      confirmCredential: updateObject(loginfieldsState.confirmCredential, {
        isError: true,
        isPasswordMismatch: true
      })
    })
    errors.push(getNotification(loginFieldsSchema, 'confirmCredential'))
  }

  setLoginErrors(errors)
  return errors.length
}
